var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticStyle:{"border-radius":"12px"},attrs:{"value":_vm.displayLoginWindow,"max-width":_vm.modalSize,"persistent":"","content-class":"white"}},[_c('login-window',{on:{"navigate":_vm.navigate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }